import { forwardRef } from "react";

const Th = forwardRef(({ text, bgColor = "bg-gray-200" }, ref) => {
  return (
    <th
      ref={ref}
      scope="col"
      className={`py-3 px-6 text-md font-bold whitespace-nowrap break-words text-left
        tracking-wider text-gray-700 uppercase first-of-type:rounded-tl-lg 
        last-of-type:rounded-tr-lg ${bgColor}`}
    >
      {text}
    </th>
  );
});

Th.displayName = "Th";

export default Th;
